module.exports = __webpack_public_path__ + "static/media/receipt_icon.698538f5.svg";